const recursiveWhere = ( arr, condition ) => {

    const [ whereItem, ...newArr ] = arr;

    if(newArr.length){
        return {
            ...whereItem,
            [ condition ] : [{ ...recursiveWhere( newArr, condition)}]
        };
    }

    return whereItem;

};


export const whereConditionBuilder = ( filterObj, condition = "AND" ) => {

    let whereArr = [];

    for( let [ key, item ] of Object.entries( filterObj )){

        const { label, ...filterItem } = item;

        if( typeof filterItem === "object"){
            if( Object.keys( filterItem ).length ){

                whereArr.push( { ...filterItem} );

            }
        } else {
            if( filterItem ){
                whereArr.push(
                    {
                        column: key.toUpperCase(),
                        operator: "IN",
                        value: filterItem
                    }
                )
            }
        }

    }

    return recursiveWhere( whereArr.reverse(), condition );

};
